// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"tickets_scroll-black__s0yrR","main-image":"tickets_main-image__zyL6a","overlay":"tickets_overlay__hbtFP","main-text":"tickets_main-text__KpWTB"};